import React from 'react';

import type { ResponsiveNavigationItemBaseProps } from '../ResponsiveNavigationItemBase';
import { ResponsiveNavigationItemBase } from '../ResponsiveNavigationItemBase';

export type ResponsiveFlyoutItemProps = Omit<
  ResponsiveNavigationItemBaseProps,
  'listItemClassNames' | 'linkClassNames'
>;

/**
 * Navigation item for the popup navigation (only visible on user interaction)
 */
export const ResponsiveFlyoutItem = React.memo(
  ({ children, ...baseProps }: ResponsiveFlyoutItemProps) => {
    const { allowNavigation } = baseProps;
    return (
      <ResponsiveNavigationItemBase
        {...baseProps}
        listItemClassNames="items-start max-lg:border-b max-lg:border-b-color-grey"
        linkClassNames="px-2 lg:px-0 lg:pl-1 py-1.5 lg:py-0 text-size-h3 justify-between transition-colors duration-200 hover:bg-color-background-base"
      >
        {/* NOTE top margin is used instead of centering to allow top-alignment in the `li` combined with having the arrow centered with the first line of text */}
        <span className="text-size-headline-base relative my-0.5">{children}</span>
        {!allowNavigation && <span className="icon-emp-arrow-medium-right size-4" />}
      </ResponsiveNavigationItemBase>
    );
  },
);
